import React from 'react';
import { ProductGalleryProps } from './types';
import LazyImage from '../LazyImage';

const ProductGallery: React.FC<ProductGalleryProps> = ({ productData, currentProduct }) => {
  if (!productData || !currentProduct || !currentProduct.media || currentProduct.media.edges.length === 0) {
    return null;
  }

  return (
    <div className="product-gallery">
      <div className="gallery-grid">
        {currentProduct.media.edges
          .filter((mediaEdge) => mediaEdge?.node?.image?.url)
          .map((mediaEdge, index: number) => (
            <div key={mediaEdge.node.id} className="gallery-item">
              <LazyImage
                src={mediaEdge.node.image.url}
                alt={`${productData.title} - View ${index + 1}`}
                className="gallery-image"
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default ProductGallery;
